import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
import styles from "./StatsCard.module.css";
export const StatsCard = ({ value, label, icon, variant = "default", className, }) => {
    return (_jsxs("div", { className: clsx(styles.card, styles[`card-${variant}`], className), children: [icon && (_jsx("div", { className: clsx(styles.iconContainer, styles[`icon-${variant}`]), children: icon })), _jsxs("div", { className: styles.content, children: [_jsx("div", { className: styles.label, children: label }), _jsx("div", { className: styles.value, children: value })] })] }));
};
